import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import {
    FaChalkboardTeacher,
    FaCheckCircle,
    FaUserTie,
    FaBriefcase,
    FaCubes,
    FaClock,
    FaPaintBrush,
    FaLaptopCode,
    FaServer,
    FaLayerGroup,
    FaBrain,
    FaChartBar,
    FaRobot,
    FaUsersCog,
    FaMicrochip,
} from "react-icons/fa";

export const HomePage = () => {

    const navigate = useNavigate();
    return (
        <div className="bg-gray-50 min-h-screen text-gray-800">
            {/* Hero Section */}
            <section className="bg-gradient-to-br from-indigo-100 to-white py-20 px-6 text-center">
                <motion.h1
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-4xl md:text-5xl font-extrabold text-primary-800 mb-4"
                >
                    Welcome to SAN Technovation
                </motion.h1>
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2, duration: 0.6 }}
                    className="max-w-2xl mx-auto text-lg md:text-xl text-gray-700"
                >
                    Empowering tomorrow’s innovators through skill-based education and
                    hands-on learning.
                </motion.p>
                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => navigate("/admission-form")}
                    className="mt-8 bg-primary-600 text-white px-8 py-3 rounded-full shadow-lg hover:bg-primary-800 transition duration-300 font-bold"
                >
                    Register Now
                </motion.button>
            </section>

            {/* Why Choose Us */}
            <section className="py-20 px-6 bg-white">
                <h2 className="text-3xl font-bold text-center text-primary-800 mb-12">
                    Why Choose SAN Technovation?
                </h2>
                <div className="max-w-6xl mx-auto grid sm:grid-cols-2 md:grid-cols-3 gap-10">
                    {[
                        { icon: <FaChalkboardTeacher size={30} />, text: "Industry-Focused Curriculum" },
                        { icon: <FaCheckCircle size={30} />, text: "Certified Courses" },
                        { icon: <FaUserTie size={30} />, text: "Expert Mentorship" },
                        { icon: <FaBriefcase size={30} />, text: "Career Support & Placements" },
                        { icon: <FaCubes size={30} />, text: "Real-world Projects" },
                        { icon: <FaClock size={30} />, text: "Flexible Learning Options" },
                    ].map((item, index) => (
                        <motion.div
                            key={index}
                            whileHover={{ y: -5 }}
                            className="bg-secondary-50 p-6 rounded-xl shadow-md text-center hover:shadow-lg transition block md:flex md:gap-7"
                        >
                            <span className="mb-3 text-secondary-600">{item.icon}</span>
                            <p className="text-lg font-medium text-primary-800">{item.text}</p>
                        </motion.div>
                    ))}
                </div>
            </section>


            {/* Our Key Programs */}
            <section className="py-20 px-6 bg-gray-100">
                <h2 className="text-3xl font-bold text-center text-primary-800 mb-12">
                    Our Key Programs
                </h2>
                <div className="max-w-7xl mx-auto grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
                    {[
                        {
                            title: "Embedded Systems",
                            desc: "Design and develop hardware-integrated systems using microcontrollers and C/C++.",
                            icon: <FaMicrochip size={24} />,
                        },
                        {
                            title: "Data Science",
                            desc: "Explore data manipulation, statistics, and machine learning to derive meaningful insights.",
                            icon: <FaBrain size={24} />,
                        },
                        {
                            title: "Data Analytics/ Visualization",
                            desc: "Learn to analyze large datasets and present them through interactive dashboards and visuals.",
                            icon: <FaChartBar size={24} />,
                        },
                        {
                            title: "Artifical Intelligence/ Machine Learning",
                            desc: "Build intelligent systems that learn from data using Python and modern AI frameworks.",
                            icon: <FaRobot size={24} />,
                        },
                        {
                            title: "HR Data Analytics",
                            desc: "Use data-driven insights to enhance HR decision-making and employee performance.",
                            icon: <FaUsersCog size={24} />,
                        },
                        {
                            title: "UI/UX Design",
                            desc: "Learn to create stunning and user-friendly digital interfaces using tools like Figma and Adobe XD.",
                            icon: <FaPaintBrush size={24} />,
                        },
                        {
                            title: "Frontend Development",
                            desc: "Build responsive and interactive websites using HTML, CSS, JavaScript, and React.",
                            icon: <FaLaptopCode size={24} />,
                        },
                        {
                            title: "Backend Development",
                            desc: "Learn server-side logic, APIs, and databases using Node.js, Express, and MongoDB.",
                            icon: <FaServer size={24} />,
                        },
                        {
                            title: "Full Stack Development - MERN",
                            desc: "Master front-end and back-end technologies to build complete web applications.",
                            icon: <FaLayerGroup size={24} />,
                        },


                    ].map((program, idx) => (
                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: idx * 0.1 }}
                            className="bg-white p-6 rounded-xl shadow hover:shadow-xl transition"
                        >
                            <div className="text-secondary-600 mb-2">{program.icon}</div>
                            <h3 className="text-xl font-semibold text-primary-800 mb-2">
                                {program.title}
                            </h3>
                            <p className="text-sm text-gray-600">{program.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </section>

        </div>
    );
};

